import * as ActionTypes from 'state/types'
import { Session, TabSession } from 'shared/utils/storage'
import { sortByName } from 'shared/utils/array'

export default (state = {
  isFailure: false,
  isRequesting: false,
  isCreating: false,
  active: null
}, action) => {
  switch (action.type) {

    case `${ActionTypes.PROFILE_REQUEST}_SUCCESS`: {

      const {
        organisations
      } = action.response.payload

      const organisationNames = organisations.map(o=> ({name: o.name, id: o.organisationId}))

      const hasOrganisations = !!organisations?.length
      const organisationId = TabSession.getItem('organisationId') || Session.getItem('lastOrganisationId')

      let activeOrganisation
      if(hasOrganisations && organisationId) {
        activeOrganisation = organisations.find(organisation => organisationId === organisation.organisationId)
      }

      if(hasOrganisations && !activeOrganisation) {
        activeOrganisation = organisations[0]
      }

      if(activeOrganisation && activeOrganisation.organisationId) {
        TabSession.setItem('organisationId', activeOrganisation.organisationId)

        activeOrganisation.projects = activeOrganisation.projects.sort(sortByName)
      }

      return {
        ...state,
        active: activeOrganisation || null,
        organisationNames,
        isRequesting: false
      }
    }

    case `${ActionTypes.SET_ORGANISATION_REQUEST}_SUCCESS`: {
      const organisation = action.response.payload

      if(!organisation) {
        console.error('Action ACTIVATE_ORGANISATION missing the organisation', action)
        return { ...state }
      }

      if(organisation && organisation.organisationId) {
        Session.setItem('lastOrganisationId', organisation.organisationId)
        TabSession.setItem('organisationId', organisation.organisationId)
      }

      return {
        state
      }
    }

    default:
      return state
  }
}
